// App.js
import React from 'react';
import { Box } from "@mui/material";
import ShipmentForm from "./widgets/ShipmentForm";
import { useParams } from "react-router-dom";



export default function EditShipmentScreen({ shipmentID }) {


  const { id } = useParams();
  return (
    <Box>
      <Box sx={{ display: 'flex' }}>
        <Box width={"100%"} m={1}>
          <ShipmentForm formType={"edit"} shipmentID={id}>

          </ShipmentForm>
        </Box>
      </Box>

    </Box>


  )
}